import { render, staticRenderFns } from "./noBgMember.vue?vue&type=template&id=7b078e4e&scoped=true&"
import script from "./noBgMember.vue?vue&type=script&lang=js&"
export * from "./noBgMember.vue?vue&type=script&lang=js&"
import style0 from "./noBgMember.vue?vue&type=style&index=0&id=7b078e4e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b078e4e",
  null
  
)

export default component.exports